import { useEffect, useState } from 'react';
import {
  deriveNeighborhoodFromLocation,
  getAllProperties,
  type Property,
  type PropertyPurpose,
  type PropertyType,
} from '@/services/properties';
import { allProperties as mockProperties } from '@/mocks/homeData';

function mockToProperty(mock: (typeof mockProperties)[number]): Property {
  return {
    id: String(mock.id),
    title: mock.title,
    type: mock.type as PropertyType,
    purpose: mock.purpose as PropertyPurpose,
    tag: mock.tag as Property['tag'],
    city: mock.city,
    neighborhood: deriveNeighborhoodFromLocation(mock.location),
    location: mock.location,
    bedrooms: mock.bedrooms,
    bathrooms: mock.bathrooms,
    parking: mock.parking,
    area: mock.area,
    price: mock.price,
    priceValue: mock.priceValue,
    description: mock.description,
    photos: [{ id: `mock-${mock.id}`, url: mock.image }],
    image: mock.image,
    driveFolderId: null,
    active: true,
    createdAt: null,
    updatedAt: null,
  };
}

const fallbackProperties = mockProperties.map(mockToProperty);

export function useProperties() {
  const [properties, setProperties] = useState<Property[] | null>(null);

  useEffect(() => {
    let active = true;

    getAllProperties()
      .then((items) => {
        if (!active) return;
        setProperties(items.length > 0 ? items : fallbackProperties);
      })
      .catch(() => {
        if (active) setProperties(fallbackProperties);
      });

    return () => {
      active = false;
    };
  }, []);

  return { properties: properties ?? fallbackProperties, loading: properties === null };
}
